export const buildConfig={date:"Mon 29 Jul 2024 19:43:10 BST"}
